/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Custom fields reducer
 */

import { CustomField } from "@thenounproject/lingo-core";

import createEntityReducer from "../helpers/createEntityReducer";
import { getEntitiesFromAction, mergeEntitiesIfChanged } from "../helpers/mergeIfChanged";

export default createEntityReducer<CustomField>(
  "fields",
  _queryBuilder => {
    // Nothing to do yet
  },
  objectBuilder => {
    objectBuilder.addDefaultCase((state, action: any) => {
      const fields = getEntitiesFromAction<CustomField>(action, "fields");
      return mergeEntitiesIfChanged(state, fields);
    });
  }
);
